/** Format a signed dollar delta-notional value as $M, e.g. +$142M, -$36M, $0M. */
export function formatDollarsM(value: number): string {
  const rounded = Math.round(value / 1_000_000);
  const sign = rounded > 0 ? "+" : rounded < 0 ? "-" : "";
  return `${sign}$${Math.abs(rounded)}M`;
}

/** Format an underlying spot price, e.g. $647.12. */
export function formatPrice(value: number): string {
  return `$${value.toFixed(2)}`;
}

/** Format a 0–100 percentage as a whole-number string with a % suffix. */
export function formatPct(value: number): string {
  return `${Math.round(value)}%`;
}
